import React from 'react';
import { Button, CircularProgress, Typography, Box } from '@mui/material';
import { formatLongDisplayDate } from '../../helpers';
import { useNavigate } from 'react-router';
import './Splash.css';
import { gameNumber } from '../../helpers/dates';

interface Props {
  isLoading: boolean;
  gameDate?: string;
  onStartRealGameClick: () => void;
  isArchiveGame?: boolean;
}

const Splash = ({
  isLoading,
  gameDate,
  onStartRealGameClick,
  isArchiveGame,
}: Props) => {
  const navigate = useNavigate();

  const goToArchive = () => navigate('/archive');
  const goToDemo = () => navigate('/demo');

  return (
    <div className="splash padding flex flex-col items-center">
      <div className="width-fit flex flex-col items-center gap-small">
        <h2 className="flex flex-col items-center">
          <span className="splash-subtitle">Welcome to</span>
          <span className="splash-header">WORMLE</span>
        </h2>

        <p className="splash-blurb">
          Use the worm to fill in the grid and spell a themed word on each row.
        </p>

        {isLoading ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            mt={2}
            mb={2}
          >
            <Typography
              variant="body1"
              sx={{ color: 'white', fontWeight: 500, mb: 1 }}
            >
              Game Loading…
            </Typography>
            <CircularProgress size={40} sx={{ color: 'white' }} />
          </Box>
        ) : (
          <>
            <p className="splash-game-num">
              {gameDate &&
                (isArchiveGame
                  ? `Archive Game #${gameNumber(gameDate)}`
                  : `Today's Game #${gameNumber(gameDate)}`)}
            </p>
            <p className="splash-date">
              {gameDate ? formatLongDisplayDate(gameDate) : ''}
            </p>
            <Button
              className="splash-button"
              style={{ border: 'none' }}
              fullWidth
              variant="outlined"
              size="large"
              onClick={onStartRealGameClick}
            >
              Play
            </Button>
            <Button
              className="splash-button"
              style={{ border: 'none' }}
              variant="outlined"
              size="large"
              fullWidth
              onClick={goToArchive}
            >
              Archive
            </Button>
            <Button
              className="splash-button"
              style={{ border: 'none' }}
              variant="outlined"
              size="large"
              fullWidth
              onClick={goToDemo}
            >
              Try demo
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default Splash;
